import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { CheckCircleOutline as CheckIcon, ArrowForward as ArrowIcon } from '@mui/icons-material';
import { BRAND, Lnk, BottomCta, usePageMeta } from './shared';
import { getSolution } from './solutionsData';

const SolutionDetail: React.FC = () => {
  const { slug } = useParams();
  const sol = getSolution(slug);
  usePageMeta(sol ? sol.name : 'Solutions');

  if (!sol) return <Navigate to="/solutions" replace />;

  return (
    <>
      <section className="page-head">
        <div className="container">
          <p className="kicker">Solutions</p>
          <h1>{sol.name}</h1>
          <p>{sol.tagline}</p>
        </div>
      </section>

      <section className="page-body">
        <div className="container">
          <div className="prose" style={{ marginBottom: 36 }}>
            <p style={{ fontSize: '1.08rem' }}>{sol.intro}</p>
          </div>

          <div className="group">
            <div className="group-head"><h2>What you can do</h2></div>
            <ul className="check-list">
              {sol.highlights.map((h) => (
                <li key={h}><CheckIcon aria-hidden="true" /> <span>{h}</span></li>
              ))}
            </ul>
          </div>

          <div className="group">
            <div className="group-head"><h2>Best for</h2></div>
            <div className="pill-list">
              {sol.bestFor.map((b) => <span className="pill" key={b}>{b}</span>)}
            </div>
          </div>

          <p style={{ marginTop: 8 }}>
            <Lnk to="/solutions" className="btn btn-link" style={{ paddingLeft: 0 }}>
              <ArrowIcon style={{ fontSize: 16, transform: 'rotate(180deg)' }} aria-hidden="true" /> All solutions
            </Lnk>
          </p>
        </div>
      </section>

      <BottomCta title={`See how ${BRAND} works for ${sol.name.toLowerCase()}.`} />
    </>
  );
};

export default SolutionDetail;
